import { Button, Container, Grid, Paper, Typography } from '@material-ui/core';
import {makeStyles}from '@material-ui/core/styles';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import HorizontalCards from '../../Slider/HorizontalCards';
import SliderCard from '../../Slider/SliderCard';





const useStyles = makeStyles((theme) => ({
    root:{
        position:"relative",
        paddingTop:"160px",
        [theme.breakpoints.down("md")]:{
            display:"none",
        }
        
    },
    button:{
        backgroundColor:"#5A8EC1",
        float:"left",
        
    },
    slideMedia:{
        // display:"none",
        // [theme.breakpoints.up("md")]:{
        //     display:"block ",
        //     backgroundColor:"seagreen",
        // },
        
    },
    text:{
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        alignContent:"center"
    },
    mobView:{
        display:"none",
        [theme.breakpoints.down("md")]:{
            display:"block ",
            // backgroundColor:"seagreen",
        },
    }
}));

export default function Images() {

    const classes = useStyles();


  return (
    <Fragment>
         
        <div className={classes.mobView}>
        <marquee behavior="scroll" direction="right">
            <img src="/asserts/images/78nE.gif" width="125" height="82" alt="Flying Bat"/>
            </marquee>
        <Typography className="mb-5" variant="h3" align = "center">
                            Agro-Tourism
                        </Typography>
            <SliderCard />
            <Typography className="mt-3" variant="subtitle1" align = "left">
            Agrotourism is a concept that draws its origins from Italy and literally means tourism related to agriculture.Uddibaba is surrounded by farmland that we are gradually utilising
            for food and Ayurvedic medicine productions.
                    </Typography>
            <Typography variant="subtitle1" align = "left">
            This way, the issues of fetching buyers and dealing with the precarious logistics of the hilly areas disappear at once, making it a sustainable and effective solution to hill emigration.
                    </Typography>
        </div>
        <Container className={classes.root} >
        <marquee behavior="scroll" direction="right">
            <img src="/asserts/images/78nE.gif" width="125" height="82" alt="Flying Bat"/>
            </marquee>
        
            <Grid container spacing={4}>
                
                <Grid item xs={11} sm={11} md={8} lg={8} >
                            <div className = {classes.slideMedia}>
                            <HorizontalCards style={{padding:"25px", overflowX:"hidden"}} />
                            </div> 
                        </Grid>
                
                {/* <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <Grid item xs={12} sm={12} md={6} lg={6} >
                            <div className = {classes.slideMedia}>
                            <HorizontalCards />
                            </div> 
                        </Grid>
                    </div>
                </div> */}

                <Grid item xs={12} sm={12} md={4} lg={4} style={{background:"none", overflowX:"hidden"}} >
                    <div className="container  mt-5">

                    <Paper style={{boxShadow:"none", background:"none"}} className="mt-5" >
                    <Typography variant="h3" align = "left">
                            Agro-Tourism
                        </Typography>
                        {/* <Button
                        size="small"
                        className= {classes.button}
                        component = {Link}
                        variant="text"
                        to='/blog'
                        
                        >
                            Our Blogs
                        </Button> */}
                    </Paper>
                    {/* <br/> */}
                    <div className = {classes.text}>
                        
                    <Typography variant="subtitle1" align = "left">
                    Agrotourism is a concept that draws its origins from Italy and literally means tourism related to agriculture.Uddibaba is surrounded by farmland that we are gradually utilising
                    for food and Ayurvedic medicine productions.
                    </Typography>
                    <br/>
                    <Typography variant="subtitle1" align = "left">
                                This way, the issues of fetching buyers and dealing with the precarious logistics of the hilly areas disappear at once, making it a sustainable and effective solution to hill emigration.
.
                    </Typography>
                    <br/>
                    {/* <Typography variant="subtitle1" align = "left">
                        Lorem ipsum dolor, sit amet consectetur adipisicing elit. A ullam, aliquid, 
                        possimus voluptate ipsam veritatis qui cupiditate ad 
                        nesciunt modi provident consequatur quaerat delectus eos amet consequuntur, laboriosam enim labore.
                    </Typography> */}
                    </div>


                    </div>
                    
                    
                </Grid>

            </Grid>
        </Container>
    </Fragment>
  );
}
